import React, { useState, useContext } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { Button, Input, Form, ConfigProvider } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import logo from '../../assets/logo.png'
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import styles from '../../services/styles';


const { tc1, tc2, bc1, bc2, bc4, bc7, COLORS } = styles


export default function ChangePassword(props) {

    const [searchParams, setSearchParams] = useSearchParams();

    const token = localStorage.getItem('token')
    const currentUser = null

    const { mobile_mode } = useContext(GeneralContext)

    const [newPassword, setNewPassword] = useState(null)
    const [confirmedNewPassword, setConfirmedNewPassword] = useState(null)
    const [formRef] = Form.useForm()


    const onFinish = (values) => {

        if (!newPassword || !confirmedNewPassword) { alert(displayMessage('FILL_ALL_FIELDS_RESET_PASSWORD')); return }
        if (newPassword != confirmedNewPassword) { alert(displayMessage('PASSWORD_CONFIRMATION_FAILED')); return }

        const payload = { newPassword: values.new_password }

        api.auth.changePasswordForced(payload).then(
            rs => {
                if (rs.status == 200) {
                    setTimeout(() => window.location.href = "/users", 1500)
                    alert(displayMessage('RESET_PASSWORD_SUCCESS'), "success")
                }
            }
        )

    }

    return (
            <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ height: '100%', background: COLORS.GRAY[50], display: mobile_mode ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', flex: 2 }}>
                    <img
                        src={logo}
                        style={{ width: '100%', maxWidth: 700, minWidth: 200 }}
                    />
                </div>

                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        position: 'relative',
                        minWidth: !mobile_mode && 450,
                        backgroundColor: COLORS.GREEN[900],
                        boxShadow: !mobile_mode && '-5px 0px 13px 0px rgba(20,83,45,0.3)',
                        flexDirection: 'column',
                        padding: 20
                    }}
                >
                    {/* Wave */}
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                        </g>
                    </svg>
                    <>

                        <div
                            style={{
                                color: tc1,
                                fontWeight: 'bold',
                                marginBottom: 15,
                                fontSize: mobile_mode ? 20 : 24,
                                textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                color: bc2,
                            }}
                        >
                            {displayMessage('CHANGE_PASSWORD_TITLE')}
                        </div>

                        <Form
                            name="reset_password"
                            onFinish={onFinish}
                            style={{ maxWidth: 400, width: '100%' }}
                            layout='vertical'
                            form={formRef}
                        >
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorError: COLORS.RED[650]  // Mantém vermelho para erros de validação
                                    },
                                }}
                            >
                                <div style={{ display: 'flex', gap: 2, flexDirection: 'column'}}>
                                    <div
                                        style={{
                                            color: COLORS.GRAY[50],
                                            textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                            fontWeight: 'bold',
                                            display: 'flex'
                                        }}>
                                            {displayMessage('NEW_PASSWORD_SHORT')}   
                                    </div>

                                    <Form.Item
                                        name="new_password"
                                        // className={`flex-1`}
                                        rules={[{ required: true, message: displayMessage('PASSWORD_MANDATORY') }]}
                                    >
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type="password"
                                            placeholder={displayMessage('NEW_PASSWORD_SHORT')}
                                            autoComplete="do-not-use-auto-complete"
                                            value={newPassword}
                                            onChange={
                                                e => {
                                                    setNewPassword(e.target.value)
                                                }
                                            }
                                        />
                                    </Form.Item>
                                </div>
                                <div style={{ display: 'flex', gap: 2, flexDirection: 'column', marginTop: 5 }}>
                                    <div
                                        style={{
                                            color: COLORS.GRAY[50],
                                            textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                            fontWeight: 'bold',
                                            display: 'flex'
                                        }}>
                                        {displayMessage('CONFIRM_PASSWORD')}
                                    </div>

                                    <Form.Item
                                        name="confirm_password"
                                        className={`flex-1`}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message: displayMessage('DISPLAY_CONFIRM_PASSWORD')
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('new_password') === value) {
                                                        return Promise.resolve()
                                                    }
                                                    return Promise.reject(new Error(displayMessage('INVALID_CONFIRMED_PASSWORD')))
                                                }
                                            })
                                        ]}
                                    >
                                        <div>
                                            <Input
                                                prefix={<LockOutlined className="site-form-item-icon" />}
                                                type="password"
                                                value={confirmedNewPassword}
                                                placeholder={displayMessage('CONFIRM_PASSWORD')}
                                                onChange={
                                                    e => {
                                                        setConfirmedNewPassword(e.target.value)
                                                    }
                                                }
                                               
                                            />
                                        </div>
                                    </Form.Item>
                                </div>
                            </ConfigProvider>

                            <Form.Item hasFeedback style={{ marginBottom: 10, marginTop: 5 }}>
                                <Button 
                                    type="primary" 
                                    style={{
                                        width: "100%",
                                        fontWeight: 'bold',
                                        textShadow: '0px 0px 5px #666',
                                    }} 
                                    htmlType="submit"
                                >
                                    {displayMessage('REDEFINE_PASSWORD')}
                                </Button>
                            </Form.Item>

                        </Form>
                    </>
                </div>
            </div>
    )
}